"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var RequiredInputForTable = function RequiredInputForTable(_ref) {
  var children = _ref.children,
      validateFunc = _ref.validateFunc,
      requiredText = _ref.requiredText,
      name = _ref.name;

  var checkRequired = function checkRequired(input, validateFunc) {
    var props = Object.assign({}, input.props);
    var className = !!input.props.className ? input.props.className : "";

    if (!input.props.value || !validateFunc(input.props.value)) {
      className += " is-invalid";
      props.required = true;
    }

    props.className = className;
    return _react["default"].cloneElement(input, props);
  };

  return _react["default"].createElement("div", {
    id: "required-input-for-table",
    name: name
  }, _react["default"].Children.map(children, function (child) {
    return checkRequired(child, validateFunc);
  }), requiredText ? _react["default"].createElement("div", {
    className: "invalid-feedback"
  }, requiredText) : null);
};

var validateFunc = function validateFunc(value) {
  if (!value) {
    // number would only fall in here if 0, otherwise it's not a number and is invalid
    return _typeof(value) === _typeof(-1);
  } else {
    if (_typeof(value) === _typeof("")) {
      return value.trim();
    } else if (_typeof(value) === _typeof(-1)) {
      //default value for not set
      return value !== -1;
    } else {
      return true;
    }
  }
};

RequiredInputForTable.propTypes = {
  name: _propTypes["default"].string.isRequired,
  requiredText: _propTypes["default"].string,
  children: _propTypes["default"].object.isRequired,
  validateFunc: _propTypes["default"].func
};
RequiredInputForTable.defaultProps = {
  name: "",
  requiredText: null,
  children: {
    props: {}
  },
  validateFunc: validateFunc
};
var _default = RequiredInputForTable;
exports["default"] = _default;